function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import SceneComponentWrapper from "./SceneComponentWrapper";
var tKey = "contexts.SceneContext";
export var SceneContext = /*#__PURE__*/React.createContext({});
export var SceneProvider = function SceneProvider(_ref) {
  var _ref2;
  var children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    balances = _useState2[0],
    setBalances = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    maxCoins = _useState4[0],
    setMaxCoins = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dialogOpen = _useState6[0],
    setDialogOpen = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    gravity = _useState8[0],
    setGravity = _useState8[1];
  var gravityArr = [{
    label: t("".concat(tKey, ".moon")),
    value: 1.7
  }, {
    label: t("".concat(tKey, ".mars")),
    value: 3.7
  }, {
    label: t("".concat(tKey, ".earth")),
    value: 9.8
  }, {
    label: t("".concat(tKey, ".jupiter")),
    value: 24.7
  }];
  var handleGravityChange = function handleGravityChange(event, newValue) {
    setGravity(newValue);
  };
  var toggleSceneDialog = function toggleSceneDialog(balances, maxCoins) {
    setBalances(balances);
    setMaxCoins(maxCoins);
    setDialogOpen(!dialogOpen);
  };
  return /*#__PURE__*/React.createElement(SceneContext.Provider, {
    value: {
      toggleSceneDialog: toggleSceneDialog
    }
  }, children, dialogOpen && /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: true,
    open: dialogOpen,
    onClose: function onClose() {
      return setDialogOpen(false);
    },
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    PaperProps: {
      sx: {
        backgroundColor: function backgroundColor(theme) {
          return theme.palette.background.default;
        },
        backgroundImage: "none"
      }
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    onClick: function onClick() {
      return setDialogOpen(false);
    },
    sx: (_ref2 = {
      position: "absolute",
      top: 16,
      right: 16,
      color: "white",
      zIndex: 1,
      borderRadius: "50%",
      padding: "8px"
    }, _defineProperty(_ref2, "color", "white"), _defineProperty(_ref2, "backgroundColor", "rgba(0, 0, 0, 0.3)"), _defineProperty(_ref2, "&:hover", {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    }), _defineProperty(_ref2, "boxShadow", "0px 4px 12px rgba(0, 0, 0, 0.2)"), _ref2)
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: "absolute",
      top: 60,
      right: 16,
      display: "flex",
      flexDirection: "column",
      alignItems: "end"
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      borderRadius: "12px",
      padding: 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: 200,
      color: "white",
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.5)"
      },
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React.createElement(Slider, {
    color: "white",
    value: gravity,
    onChange: handleGravityChange,
    "aria-labelledby": "gravity-slider",
    step: 1,
    min: 0,
    max: 3,
    orientation: "vertical",
    valueLabelDisplay: "auto",
    valueLabelFormat: function valueLabelFormat(value) {
      return gravityArr[value].label;
    },
    sx: {
      height: "150px"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    align: "center",
    sx: {
      color: "white",
      marginTop: 1
    }
  }, gravityArr[gravity].label))), /*#__PURE__*/React.createElement(SceneComponentWrapper, {
    balances: balances,
    maxCoins: maxCoins,
    gravity: gravityArr[gravity].value
  })));
};
export var useSceneContext = function useSceneContext() {
  var context = useContext(SceneContext);
  if (!context) throw new Error("useSceneContext must be used within a SceneProvider");
  return context;
};